export default __webpack_public_path__ + "static/media/red beanie.dd492d97.png";